
import { mapGetters, mapActions } from "vuex"
import debounce from "lodash/debounce"
import { storageKeys, getLs, setLs } from "@/utils/storage"

export default {
  // scrollToTop: false,

  async asyncData ({ route, $api, redirect, app }) {
    const programApi = $api.program
    const { getList } = $api.helpers

    let [res, err] = await programApi.getDays()
    if (err) {
      console.error(err)
      return
    }
    const days = getList(res);

    [res, err] = await programApi.getGroups()
    if (err) {
      console.error(err)
      return
    }
    const groups = getList(res)

    if (days.length && groups.length) {
      const query = { ...route.query }
      const { day, group } = query

      const isDayWrong = !day || !days.find(d => d.alias === day)
      const isGroupWrong = !group || !groups.find(g => g.alias === group)

      if (isDayWrong || isGroupWrong) {
        if (isDayWrong) query.day = days[1].alias
        if (isGroupWrong) query.group = groups[0].alias
        return redirect(app.localePath("/program"), query)
      }
    }

    return { days, groups }
  },

  data () {
    return {
      days: [],
      groups: [],
      tracks: [],
      sessions: [],
      isOnboardingOpen: false,
    }
  },

  async fetch () {
    await this.fetchTracks()
    await this.fetchSessions()
  },

  head () {
    return { title: this.title }
  },

  computed: {
    ...mapGetters("user", ["isApprovableStatus"]),

    title () {
      return this.$t("program.title")
    },

    pdfs () {
      const base = "https://openinnovations2023.storage.yandexcloud.net/program"
      const { locale } = this.$i18n
      return {
        program: `${base}/program_${locale}.pdf`,
        sessions: `${base}/sessions_${locale}.pdf`,
      }
    },

    day: {
      get () { return this.$route.query.day || "" },
      set (v) { this.setParam("day", v) },
    },
    search: {
      get () { return this.$route.query.search || "" },
      set (v) { this.setParam("search", v) },
    },
    group: {
      get () { return this.$route.query.group || "" },
      set (v) { this.setParam("group", v) },
    },

    groupTabs () {
      const { localize } = this.$fmt
      const { query } = this.$route
      const { getGroupSessions } = this

      const tabs = []
      for (const g of this.groups) {
        if (getGroupSessions(g.alias).length) {
          tabs.push({

            title: localize(g.title),
            to: { query: { ...query, group: g.alias } },
            exact: true,
          })
        }
      }
      return tabs
    },

    groupTracks () {
      const { group } = this
      return this.tracks.filter(t => t.group.alias === group)
    },

    groupSessions () {
      return this.getGroupSessions(this.group)
    },

    isTriplePoint () {
      return this.$route.query.group === "skoltech-triple-point"
    },
  },

  watch: {
    async day () {
      await this.fetchTracks()
      await this.fetchSessions()
    },

    async search () { await this.onSearchChange() },
  },

  watchQuery (query) {
    return !query.day || !query.group
  },

  async mounted () {
    // this.openOnboarding()
    await this.fetchFavoriteSessions()
  },

  methods: {
    ...mapActions("user", ["fetchFavoriteSessions"]),

    openOnboarding () {
      if (!this.$auth.loggedIn || this.isApprovableStatus) return
      const key = storageKeys.programOnboardingWasOpen
      const wasOpen = getLs(key)
      if (wasOpen) return
      this.isOnboardingOpen = true
      setLs(key, true)
    },

    setParam (k, v) {
      this.$router.push({
        // null вместо undefined из-за сломанных .nuxt-link-exact-active
        query: { ...this.$route.query, [k]: v || null },
      })
    },

    onSearchChange: debounce(async function () {
      await this.fetchSessions()
    }, 300),

    async fetchTracks () {
      const [res, err] = await this.$api.program.getTracks({
        params: { "filter[day]": this.day },
      })
      if (err) {
        console.error(err)
        return
      }
      this.tracks = this.$api.helpers.getList(res)
    },

    async fetchSessions () {
      const [res, err] = await this.$api.program.getSessions({
        params: {
          "filter[day]": this.day,
          "filter[search]": this.search,
        },
      })
      if (err) {
        console.error(err)
        return
      }
      this.sessions = this.$api.helpers.getList(res)
    },

    getGroupSessions (group) {
      return this.sessions.filter(s => s.track.group.alias === group)
    },
  },
}
